import { createContext } from 'react'

/**
 * Provides per-item voting state to the puck ListicleVoting block, which is
 * rendered (via <Render />) inside the item's voting slot. ListicleStep3 wraps
 * each item's voting content with this provider so the block can read the
 * listicle/item ids + current tallies and dispatch a vote — the same pattern
 * poll uses with PuckPollContext.
 */
export const PuckListicleVoteContext = createContext({
  listicleId: undefined,
  itemId: undefined,
  step: undefined,
  itemTotal: undefined,
  itemPosition: undefined,
  selection: undefined,
  upvotes: undefined,
  downvotes: undefined,
  onVote: () => {},
})
